module.exports = "<h1 matDialogTitle>Confirm</h1>\n<div mat-dialog-content>{{confirmMessage}}</div>\n<div mat-dialog-actions class=\"pt-24\">\n    <button mat-raised-button class=\"mat-accent mr-16\" (click)=\"dialogRef.close(true)\">Confirm</button>\n    <button mat-button (click)=\"dialogRef.close(false)\">Cancel</button>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /vercel/path0/src/app/core/components/confirm-dialog/confirm-dialog.component.html
// module id = ../../../../../src/app/core/components/confirm-dialog/confirm-dialog.component.html
// module chunks = main